import React, { useEffect, useRef, useState } from "react";
import excelArrow from "../../assets/images/svg/excelArrow.svg";
import ReportsMenubutton from "../Header/ReportsMenubutton";
import ProfileMenuButton from "../Header/ProfileMenuButton";
import SettingsMenuButton from "../Header/SettingsMenuButton";
import { ReactComponent as DownArrow } from "../../assets/images/svg/downarrow.svg";

const ExportButton = (props) => {
  return (
    <>
      <span className="summary_extract">{props.title}</span>
      {props.type === "nifty" && <span className="nifty"></span>}
      <span className="btn_span_1" aria-hidden={true}>
        {props.inFormat ? props.inFormat : "Excel"}
      </span>
      <img className="summary_arrow" src={excelArrow} alt="" />
    </>
  );
};

const ReportsExportButton = (props) => {
  return (
    <div className="export_data_btn">
      <p className="export_data_text">Export Data</p>
      <div className="export_text_wrapper">
        <p className="export_type">Excel</p>
        <DownArrow />
      </div>
    </div>
  );
};

const getButtonComponent = ({ buttonType, ...rest }) => {
  switch (buttonType) {
    case "normalExport":
      return <ExportButton {...rest} />;
    case "reportsButton":
      return <ReportsMenubutton {...rest} />;
    case "settingsButton":
      return <SettingsMenuButton {...rest} />;
    case "headerProfileButton":
      return <ProfileMenuButton {...rest} />;
    case "reportExport":
      return <ReportsExportButton {...rest} />;

    default:
      return <ExportButton {...rest} />;
  }
};

const accessibleDropdown = (WrappedComponent) => {
  return function EnhancedComponent({
    itemRefs,
    menuItems,
    buttonProps,
    popupClassName = { open: "", close: "", wrapperClass: "" },
    btnClass = "",
    accessibilityValues,
    isDropdownDisabled = false,
    onCustomClose = () => {},
    ...rest
  }) {
    const [isOpen, setIsOpen] = useState(false);

    const buttonRef = useRef(null);
    const menuRef = useRef(null);

    // const openMenu = () => {
    //   setIsOpen(true);
    // };

    const closeMenu = () => {
      setIsOpen(false);
      onCustomClose(true);
    };

    const focusMenuItem = (index) => {
      itemRefs.current[index]?.focus();
    };

    const handleButtonKeyDown = (e) => {
      switch (e.key) {
        case "Enter":
        case " ":
          e.preventDefault();

          if (!isOpen) {
            setIsOpen(true);
          } else {
            focusMenuItem(0);
          }
          break;

        case "ArrowDown":
          e.preventDefault();

          if (!isOpen) {
            setIsOpen(true);

            setTimeout(() => {
              focusMenuItem(0);
            }, 100);
          } else {
            focusMenuItem(0);
          }
          break;

        case "ArrowUp":
          e.preventDefault();

          if (!isOpen) {
            setIsOpen(true);

            setTimeout(() => {
              focusMenuItem(menuItems.length - 1);
            }, 100);
          } else {
            focusMenuItem(menuItems.length - 1);
          }
          break;

        case "Escape":
          setIsOpen(false);
          onCustomClose(true);
          break;
      }
    };

    const handleItemKeyDown = (e, index) => {
      switch (e.key) {
        case "ArrowDown":
          e.preventDefault();
          focusMenuItem((index + 1) % menuItems.length);
          break;

        case "ArrowUp":
          e.preventDefault();
          focusMenuItem((index - 1 + menuItems.length) % menuItems.length);
          break;

        case "Home":
          e.preventDefault();
          focusMenuItem(0);
          break;

        case "End":
          e.preventDefault();
          focusMenuItem(menuItems.length - 1);
          break;

        case "Escape":
          e.preventDefault();
          closeMenu();
          buttonRef.current?.focus();
          break;

        case "Tab":
          closeMenu();
          break;

        default:
          break;
      }
    };

    const handleMenuItemClick = (
      isOptionsClosed,
      isFocusMenuButton = false,
    ) => {
      if (isOptionsClosed) {
        setIsOpen(false);
        onCustomClose(true);
      }
      if (isFocusMenuButton) {
        buttonRef.current.focus();
      }
    };

    useEffect(() => {
      const handleOutsideClick = (event) => {
        if (
          !menuRef.current?.contains(event.target) &&
          !buttonRef.current?.contains(event.target)
        ) {
          closeMenu();
        }
      };

      document.addEventListener("mousedown", handleOutsideClick);

      return () => {
        document.removeEventListener("mousedown", handleOutsideClick);
      };
    }, []);

    return (
      <div
        className={popupClassName.wrapperClass}
        // onMouseEnter={openMenu}
        // onMouseLeave={closeMenu}
      >
        <div
          className={`children buttonWrapper ${btnClass}`}
          style={{ width: "fit-content" }}
        >
          <div className="summary_data">
            <button
              id={accessibilityValues.buttonId}
              ref={buttonRef}
              disabled={isDropdownDisabled}
              className="summary_button"
              aria-haspopup={accessibilityValues.ariaHaspopup}
              aria-expanded={isOpen}
              aria-controls={accessibilityValues.ariaControls}
              onClick={() => setIsOpen((prev) => !prev)}
              onKeyDown={handleButtonKeyDown}
            >
              {getButtonComponent(buttonProps)}
            </button>
          </div>
        </div>
        {isOpen && (
          <WrappedComponent
            {...rest}
            popupClassName={popupClassName}
            menuItems={menuItems}
            isOpen={isOpen}
            handleItemKeyDown={(e, index) => handleItemKeyDown(e, index)}
            handleMenuItemClick={(isClosed) => handleMenuItemClick(isClosed)}
            itemRefs={itemRefs}
            ref={menuRef}
            accessibilityValues={accessibilityValues}
          />
        )}
      </div>
    );
  };
};

export default accessibleDropdown;
